export const setViewportProps = () => {
  const newWidth = window.innerWidth
  const newHeight = window.innerHeight
  const newunitVw = newWidth * 0.01
  const newunitVh = newHeight * 0.01
  let newunitVmin = 0
  let newunitVmax = 0

  // calculate vmin from lowest value, and opposite for vmax
  newunitVmin = Math.min(newWidth, newHeight) * 0.01
  newunitVmax = Math.max(newWidth, newHeight) * 0.01

  // apply css variables
  document.documentElement.style.setProperty('--vw', `${newunitVw}px`)
  document.documentElement.style.setProperty('--vh', `${newunitVh}px`)
  document.documentElement.style.setProperty('--vmin', `${newunitVmin}px`)
  document.documentElement.style.setProperty('--vmax', `${newunitVmax}px`)
}
